import { generateTestId } from "@client-shared";

export const setHomeViewTestId = (identifier: string): string =>
  generateTestId("HomeView", identifier);
